import { action, observable } from 'mobx';
import { IProduct } from '../interfaces/IRating';
import { PowerReviewsProduct } from '../domain/entities/PowerReviewsProduct';
import { Config } from '../domain/entities/Config';

export class ProductRepository {
    @observable public products: IProduct[] = [];
    @observable public productId: string = '';
    @observable public selectedSkuId: string = '';
    @observable public configService: Config;
    @observable public paginationType: string = '';

    constructor(configService: Config) {
        this.configService = configService;
    }

    @action
    public updateProductId = (productId: string) => {
        this.productId = productId;
    };

    @action
    public setPaginationType = (paginationType: string) => {
        this.paginationType = paginationType;
    };

    @action
    public setSelectedSkuId = (skuId: string) => {
        this.selectedSkuId = skuId;
    };

    @action
    public setProducts = (products: IProduct[]) => {
        const listOfProducts = [...this.products, ...products];

        this.products = listOfProducts.filter(
            (product, index, arr) =>
                arr.findIndex((i) => i.productId === product.productId) === index
        );
    };

    public getProductById = (productId: string) =>
        <IProduct>this.products.find((prod: IProduct) => prod.productId === productId);

    public getPowerReviewsProduct(products: IProduct[]) {
        const {
            ratingsReviewsConfig,
            brand: { literal: brandName }
        } = this.configService.config;

        return PowerReviewsProduct.fromJson(
            products[0],
            { ...ratingsReviewsConfig, brandName },
            this.paginationType,
            this.selectedSkuId
        );
    }
}
